export default "/_next/static/images/large_curved_arrow-c11db63e4dd7e699c3b36d9fb90b9a2d.gif";